import React, {  Component } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'components';
import NpsNumber from '../NpsNumber';
/** MOCK ARRAY TO RENDER NpsNumber Component*/
const number = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10' ];

class Questionnaire extends Component {
   
    static propTypes = { 
      questionText: PropTypes.string, 
      questionCode: PropTypes.string,
      handleClick: PropTypes.func,
      onSelectNumber:   PropTypes.func,
    }
    state = { 
      selected: false,
      selectedNumber: '',
      questionCode: '',
    };
      
    myRef = React.createRef();
    componentDidMount(){
      this.scrollToMyRef();
    }
    
scrollToMyRef = () => this.myRef.scrollLeft = 400

handleSelectNumber = number => {
  this.props.onSelectNumber(number)
  this.setState({ selectedNumber: number });

};
handleIsSelected = status => {
  return this.state.selectedNumber === status;
};

/** MAPING OVER ARRAY FOR COMPONENT RENDERING*/
renderNpsNumber = (number)=>{
  return  number.map((el, index)=>(
    <div key={index}>
      <NpsNumber 
        number={el}
        selected={this.handleIsSelected(el)}
        handleClick={() => this.handleSelectNumber(el)}
      
      />
    </div>
  ));
}

render() {
  const { questionText }=this.props;
  return (
    <div className='Questionnaire'>
      <div className='Questionnaire__text'>
        <Typography align='center' bold  type='heading5'>
          {questionText}
        </Typography>
      </div>
      <div className='Questionnaire__numbers' ref={ (ref) => this.myRef=ref }
        onClick={this.props.handleClick}>
        {this.renderNpsNumber(number)}
      </div>
    </div>
  );
}
}

export default Questionnaire;